import React, { Component } from "react";
import { MCRequest } from "@eres/ejari-api/Entity/management_contract";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";

export interface MgmContractRequestsProps {
	items: MCRequest[];
}

type Props = MgmContractRequestsProps;

interface State {
}

class MgmContractRequestsListView extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		const { items } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader/>;
			} }
			renderListItem={ ( item: MCRequest, index: number ) => {
				return <RenderListItem
					key={ `${ index }_${ item.ContractNumber }` }
					item={ item }/>;
			} }/>;
	}
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.mgm_contract_no }</th>
		<th>{ Strings.status }</th>
		<th>{ Strings.company_name }</th>
		<th>{ Strings.contract_start_date }</th>
		<th>{ Strings.contract_end_date }</th>
		<th>{ Strings.request_date }</th>
		<th>{ Strings.reason }</th>
	</tr>;
}

function RenderListItem( props: { item: MCRequest } ) {
	const { item } = props;
	const terminateReqDate = item.TerminationDate ? item.TerminationDate.asDate().asSimpleDateString() : undefined;
	const startDate = item.StartDate ? item.StartDate.asDate().asSimpleDateString() : "-";
	const endDate = item.EndDate ? item.EndDate.asDate().asSimpleDateString() : "-";
	let company = "-";
	let status = "-";
	if ( item.ContractStatus && item.ContractStatus.Identity ) {
		status = LocaleUtil.getLocalValue( { en: item.ContractStatus.NameEn, ar: item.ContractStatus.NameAr } );
	}
	if ( item.ManagementCompany && item.ManagementCompany.Identity ) {
		company = LocaleUtil.getLocalValue( { en: item.ManagementCompany.NameEn, ar: item.ManagementCompany.NameAr } );
	}
	let reason = undefined;
	if ( item.TerminationReason ) {
		reason = LocaleUtil.getLocalValue( { en: item.TerminationReason.NameEn, ar: item.TerminationReason.NameAr } );
	}
	return <tr data-item={ JSON.stringify( item ) }>
		<td data-label={ Strings.mgm_contract_no }>{ item.ContractNumber }</td>
		<td data-label={ Strings.status }>{ status }</td>
		<td data-label={ Strings.company_name }>{ company }</td>
		<td data-label={ Strings.contract_start_date }>{ startDate }</td>
		<td data-label={ Strings.contract_end_date }>{ endDate }</td>
		<td data-label={ Strings.request_date }>{ terminateReqDate ?? "-" }</td>
		<td data-label={ Strings.reason }>{ reason ?? "-" }</td>
	</tr>;
}

export default MgmContractRequestsListView;